import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Switch, Box, Typography } from "@mui/material";
import variableStyles from "../../../theme/variable-styles";
import Lang, { changeLanguage, CountryLanguage } from "../../../i18n/i18n";
import UserService from "../../../services/api/user.service";
import { authTokens } from "../../../services/services";
import { ITokenPayload } from "../../../models/user";

const LanguageSwitch = styled(Switch)(({ theme }) => ({
  width: 50,
  height: 24,
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(27px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: variableStyles.MainColor,
        opacity: 1
      }
    }
  },
  "& .MuiSwitch-thumb": {
    width: 20,
    height: 20,
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0,0,0,0.3)"
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: variableStyles.MainColor,
    opacity: 1
  }
}));

const LanguageToggle: React.FC = () => {
  const [userInfo, setUserInfo] = useState<ITokenPayload | null>(null);
  const isFirstRun = React.useRef(true);
  const [checked, setChecked] = useState(false);

  const getToken = async () => {
    const user = await authTokens.getUser();
    if (user) {
      setUserInfo(user);

      const isChecked = user.language === CountryLanguage.EN ? true : false;
      setChecked(isChecked);
    }
  };

  useEffect(() => {
    getToken();
  }, []);

  const changeLanguage = async (language: string) => {
    const res = await UserService.changeLanguage(language);
    localStorage.setItem("token", res.data);
    Lang.changeLanguage(language);
  };
  // Initialize from localStorage

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return; // skip lần đầu
    }

    const newLang = checked ? CountryLanguage.EN : CountryLanguage.VI;
    changeLanguage(newLang);
  }, [checked]);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography
        variant="body2"
        color={!checked ? variableStyles.MainColor : "text.secondary"}
        sx={{ fontWeight: !checked ? "bold" : "normal" }}
      >
        VI
      </Typography>

      <LanguageSwitch
        checked={checked}
        onChange={e => setChecked(e.target.checked)}
      />

      <Typography
        variant="body2"
        color={checked ? variableStyles.MainColor : "text.secondary"}
        sx={{ fontWeight: checked ? "bold" : "normal" }}
      >
        EN
      </Typography>
    </Box>
  );
};

export default LanguageToggle;
